(() => {
  const config = document.querySelector('script[data-swish-payment-display]');
  if (!config) return;
  const labels = [config.dataset.regularLabel, config.dataset.saleLabel].filter(Boolean);
  let pending = false;
  function clean() {
    pending = false;
    document.querySelectorAll('.sezzle-payment-amount').forEach(node => {
      const original = node.textContent;
      let text = original;
      labels.forEach(label => { text = text.split(label).join(''); });
      text = text.replace(/\s+/g, ' ').trim();
      if (text !== original) node.textContent = text;
    });
  }
  const observer = new MutationObserver(() => {
    if (!pending) { pending = true; requestAnimationFrame(clean); }
  });
  observer.observe(document.body, {subtree:true, childList:true, characterData:true});
  clean();
})();
